import { CREDIT_ERROR_TIPS } from 'constants/errors/credit';
import { apiClient } from 'lib/apiClient';
import {
  convertErrorToErrorDescription,
  isArcApiError,
} from 'src/services/errors';
import {
  OnErrorCallback,
  OnSuccessCarrierCallback,
} from 'src/services/orders/pay';
import { OrderDetail } from 'types/resources/orderDetail';

export const payByCarriersAu = async (
  orderId: OrderDetail['id'],
  input: {
    user_token: string;
    returnUrl: string;
    onSuccessCallback: OnSuccessCarrierCallback;
    onErrorCallback: OnErrorCallback;
  }
): Promise<void> => {
  const { user_token, returnUrl, onSuccessCallback, onErrorCallback } = input;
  const SERVICE_OPERATOR_INFO = {
    NAME: 'ウェブロール',
    TEL: '050-3786-3313',
  };

  try {
    const buy_res = await apiClient.v1.orders
      ._orderId(orderId)
      .payments.carriers.au.post({
        headers: {
          Authorization: `Bearer ${user_token}`,
        },
        body: {
          return_url: returnUrl,
          error_url: returnUrl,
          service_name: SERVICE_OPERATOR_INFO.NAME,
          service_tel: SERVICE_OPERATOR_INFO.TEL,
        },
      });

    if (buy_res.status == 200) {
      onSuccessCallback(
        orderId,
        buy_res.body.access_id,
        buy_res.body.start_url,
        buy_res.body.token
      );
    } else {
      if (isArcApiError(buy_res.body)) {
        const errorTips = CREDIT_ERROR_TIPS[buy_res.body.code];
        onErrorCallback(
          'AU決済での購入に失敗しました',
          buy_res.body.message,
          errorTips ?? ''
        );
        return;
      }
      throw new Error('AU決済での購入に失敗しました');
    }
  } catch (e) {
    const error = convertErrorToErrorDescription(
      e,
      'AU決済での購入に失敗しました'
    );
    onErrorCallback('AU決済での購入に失敗しました', error.message);
    throw error;
  }
};
